import React, { Component } from 'react';

export default class FacebookIcon extends Component {

    render(){
        const fillStyle = {fill:this.props.fillColor}
        return (
            <svg width="100%" height="100%" viewBox="0 0 80 80" style={this.props.svgStyle}>
              <g style={fillStyle}>
                <path d="M55.208,79.97l-12.487,0l0,-30.865l-10.452,0l0,-12.164l10.396,0l0,-8.881c0,-10.34 6.299,-15.966 15.517,-15.966c3.131,0.01 6.26,0.186 9.372,0.533l0,10.789l-6.37,0c-5.02,0.028 -5.976,2.392 -5.976,5.864l0,7.717l11.995,0l-1.557,12.108l-10.438,0l0,30.865Z"/>
              </g>
            </svg>
        )
    }
}
